import './HeroV2.scss';

class HeroV2 {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['HeroV2'] = HeroV2;
export default HeroV2;
